import type {
  DataResponse,
  PaginatedResponse,
  AdditionalTask,
  CreateAdditionalTaskInput,
  UpdateAdditionalTaskInput,
  ListAdditionalTasksQuery,
} from '@pms/shared';
import { api } from '@/lib/api';

export const additionalTasksService = {
  async list(query: Partial<ListAdditionalTasksQuery> = {}): Promise<PaginatedResponse<AdditionalTask>> {
    const res = await api.get<PaginatedResponse<AdditionalTask>>('/additional-tasks', { params: query });
    return res.data;
  },
  async get(id: string): Promise<AdditionalTask> {
    const res = await api.get<DataResponse<AdditionalTask>>(`/additional-tasks/${id}`);
    return res.data.data;
  },
  async create(input: CreateAdditionalTaskInput): Promise<{ id: string }> {
    const res = await api.post<DataResponse<{ id: string }>>('/additional-tasks', input);
    return res.data.data;
  },
  async update(id: string, input: UpdateAdditionalTaskInput): Promise<void> {
    await api.patch(`/additional-tasks/${id}`, input);
  },
  async remove(id: string): Promise<void> {
    await api.delete(`/additional-tasks/${id}`);
  },
};
